const { sanitiseBatchNo } = require('../../../batch/tools')
const { SHIPSY_SOURCE, STOCK_TRANSACTION_TYPES } = require('../../constants')

// Zone-movement payload:
//   { request_id, move_inventory_data: [
//       { warehouse, source_zone, destination_zone, sku_code, batch_no,
//         quantity, reason, created_at, created_by }
//     ] }
//
// A zone movement is always within a single warehouse. Both origin and
// destination on the transaction row point at the same warehouse fsid; the
// actual movement direction is captured by origin_zone / destination_zone.
async function extract (payload, { mainApi }) {
  const items = payload && payload.move_inventory_data
  if (!Array.isArray(items) || items.length === 0) return []

  const requestId = String(payload.request_id)
  const rows = []

  for (const item of items) {
    if (!item.warehouse) continue

    const location = await mainApi.location.pgAdapter.getOneByCode(item.warehouse)

    rows.push({
      source: SHIPSY_SOURCE,
      type: STOCK_TRANSACTION_TYPES.ZONE_MOVEMENT,
      request_id: requestId,
      origin: location.fsid,
      origin_zone: item.source_zone || null,
      destination: location.fsid,
      destination_zone: item.destination_zone || null,
      sku: String(item.sku_code),
      batch: sanitiseBatchNo(item.batch_no || 'UNKNOWN'),
      quantity: Number(item.quantity),
      reason: item.reason || null,
      payload: item,
      created_at: item.created_at,
      created_by: item.created_by,
      updated_at: item.created_at,
      updated_by: item.created_by
    })
  }

  return rows
}

module.exports = extract
